import { render, staticRenderFns } from "./SalesInvoiceViewDetailsSalesInvoiceItemForm.vue?vue&type=template&id=5197a911"
import script from "./SalesInvoiceViewDetailsSalesInvoiceItemForm.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceViewDetailsSalesInvoiceItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports